import React, { useState } from "react";

import Box from "@mui/material/Box";
import { Tab, Tabs } from "@mui/material";
import System from "./System";
import General from "./General";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            style={{
                display: value === index ? "block" : "none",
                minHeight: "255px",
            }}
            id={`x-tabpanel-${index}`}
            aria-labelledby={`x-tab-${index}`}
            {...other}
        >
            {<Box>{children}</Box>}
        </div>
    );
}

export function BooksForm({
    formData,
    FORM_MODE,
    handleInputChange,
    allBooks

}) {

    const [tabIndex, setTabindex] = useState(0);
    const handleTabSwitch = (event, newValue) => {
        setTabindex(newValue);
    };

    return (
        <>
            {formData.Id ? (
                <Tabs
                    value={tabIndex}
                    onChange={handleTabSwitch}
                    sx={{ marginBottom: "2rem" }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="Allmänt" />
                    <Tab label="System" />
                </Tabs>
            ) : (
                <Tabs
                    value={tabIndex}
                    onChange={handleTabSwitch}
                    sx={{ marginBottom: "2rem" }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="Allmänt" />
                    <Tab label="System" />
                </Tabs>
            )}
            <TabPanel value={tabIndex} index={0}>
                <General
                    formData={formData}
                    FORM_MODE={FORM_MODE}
                    handleInputChange={handleInputChange}
                    allBooks={allBooks}
                />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
                <System
                    formData={formData}
                    FORM_MODE={FORM_MODE}
                    handleInputChange={handleInputChange}
                />
            </TabPanel>
        </>
    )
}
